var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Accordion, Flex, FormControl, FormLabel, Input, Spinner, Text, useToast } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import '@mdxeditor/editor/style.css';
import { useFocus } from "./useFocus";
import { useContentManagement } from "./ContentManagementProvider";
import { QuestionDisplay } from "../components/QuestionDisplay";
const defaults = {
    questionGroupId: null
};
function isFAQ(element) {
    return element.type === "faq";
}
export const FAQContentElement = (props) => {
    var _a, _b;
    const { isEditing } = useContentManagement();
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    const [inputs, setInputs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [questionGroup, setQuestionGroup] = useState(null);
    const toast = useToast();
    useEffect(() => {
        if (!isFAQ(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "faq", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    useEffect(() => {
        const loadGroup = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!isFAQ(props.contentElement) || props.contentElement.data == null || props.contentElement.data.questionGroupId == null) {
                return;
            }
            const response = yield fetch("/api/question_group/" + props.contentElement.data.questionGroupId);
            const data = yield response.json();
            setQuestionGroup(data.questionGroup.de_DE);
        });
        loadGroup();
    }, [props.contentElement.data]);
    if (!isFAQ(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "FAQ", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Question Group ID"),
                    React.createElement(Input, { value: (_b = (_a = props.contentElement.data.questionGroupId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "", onChange: (event) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { questionGroupId: parseInt(event.target.value) }) })) }))),
        isEditing && props.contentElement.data.questionGroupId === null ?
            React.createElement(Text, null, "Set a question group id in content settings")
            :
                questionGroup ?
                    React.createElement(Accordion, { flex: 1, allowToggle: true }, questionGroup.questions.map(question => React.createElement(QuestionDisplay, { key: question.id, question: question })))
                    :
                        React.createElement(Spinner, null)));
};
